// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"8ee0ea51","213":"32655be5","239":"e4ef7710","667":"d2e2506e"}[chunkId] + ".chunk.js";
};